export default __webpack_public_path__ + "static/media/loading.16dbc05d.gif";